<template>
  <ContentSection>
    <Container indent="center">
      <Bard
        v-if="data.text"
        :content="data.text"
        :class="{ 'text-center': data.center_text }"
      />

      <AppButton
        v-if="data.link && data.link_text"
        :to="cmsLink(data.link)"
        class="mt-8"
        variant="secondary"
      >
        {{ data.link_text }}
      </AppButton>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
const cmsLink = useCmsLink()

defineProps<{
  data: {
    text: string
    link: string
    link_text: string
    center_text: string
  }
}>()
</script>

<style>
.wysiwyg {
  p + h2,
  p + h3 {
    @apply mt-11;
  }

  h3 {
    @apply text-md md:text-xl;
  }

  h2 {
    @apply mb-3 text-md font-bold md:text-xl lg:text-2xl;
  }

  p {
    @apply leading-[1.625rem];
  }
}
</style>
